<template>
  <div>
    <CrudGrid
      :footer-text="$t('messages.items_per_page')"
      :headers="headers"
      :items="medicos"
      :search="filterSearch"
      :loading="loading"
      :page="page"
      :page-count="numberOfPages"
      :options.sync="options"
      :sort-by.sync="sortBy"
    >
      <template v-slot:header>
        <div class="header-table">
          <CrudFilter :has-filters="hasFilters" @search="applyFilter" @clear="clearFilter">
            <v-list-item>
              <v-text-field
                color="#086318"
                :label="$t('inputs.doctors.name')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.name"
              />
            </v-list-item>
          </CrudFilter>
          <v-btn class="rounded-lg ml-2" elevation="1" color="#41916b" @click="openDialog()">
            <span class="textBtn">{{ $t('buttons.new') }}</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :resource="item" @editItemGrid="openDialog(item)" />
      </template>

      <template v-slot:[`item.specialties`]="{ item }">
        <div class="d-flex flex-wrap">
          <v-chip
            v-for="(especialidade, index) in item.specialties"
            :key="index"
            color="#bce8d3"
            text-color="red"
            small
            class="ma-1"
          >
            {{ especialidade.description }}
          </v-chip>
        </div>
      </template>
    </CrudGrid>

    <Modal v-model="dialog">
      <Doctors
        :openDialog="dialog"
        :resource="resource"
        @closeDialog="dialog = false, loadGridData()"
      />
    </Modal>
  </div>
</template>

<script>
import { getDoctors } from "@/service/basic-registrations/DoctorsService";
import Doctors from "./Doctors.vue";
import Menu from "../widgets/MenuActions-comp.vue";
import CrudGrid from "../widgets/Grid.vue";
import CrudFilter from "../widgets/Filter.vue";
import Modal from "../widgets/Modal.vue";
import { mapActions } from "vuex";

export default {
  components: {
    Doctors,
    Menu,
    CrudGrid,
    CrudFilter,
    Modal,
  },

  data() {
    return {
      dialog: false,
      filterForm: {},
      filterSearch: '',
      headers: [
        { text: "CREMEB", align: "start", value: "crm" },
        { text: "Nome Profissional", align: "start", value: "name" },
        { text: "Especialidades", align: "start", value: "specialties" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      page: 1,
      numberOfPages: 0,
      loading: true,
      options: {},
      sortBy: "name",
      medicos: [],
      resource: {},
      actions: [
        {
          name: "Editar",
          type: "modal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "UsuarioForm",
        },
      ],
    };
  },

  computed: {
    hasFilters() {
      return Object.values(this.filterForm).some(v => v != null && v !== '');
    },
  },

  created() {
    this.changeActionsData(this.actions);
  },

  methods: {
    ...mapActions(["changeActionsData"]),

    loadGridData() {
      this.loading = true;
      getDoctors().then((result) => {
        this.loading = false;
        this.medicos = result;
      });
    },

    openDialog(item) {
      this.resource = item || {};
      this.dialog = true;
    },

    applyFilter() {
      this.filterSearch = this.filterForm.name || '';
    },

    clearFilter() {
      this.filterForm = {};
      this.filterSearch = '';
    },
  },

  mounted() {
    this.loadGridData();
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

@media (max-width: 768px) {
  .header-table {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
